import Tag from '@sharedComponents/Tag';
import Typography from '@sharedComponents/Typography';

// Frozen colours only: a category is business information and must not follow the client brand.
const CATEGORY_COLORS = { A: 'error', B: 'warning', C: 'lavender', D: 'disabled', M: 'lavenderDark' };

const CategoryBadge = ({ category = null }) => {
    if (!category) return <Typography color="neutral-secondary">—</Typography>;
    return (
        <Tag color={CATEGORY_COLORS[category] ?? 'disabled'} size="badge" fontSize="xs" noTruncate>
            {category}
        </Tag>
    );
};

export default CategoryBadge;
